import { translate as t } from '@thoughtspot/i18n';
import { useEffect, useRef, useState } from 'react';
import { useGetFeatureQuery, useSetTscliCommand, } from "../../../services/tscli/tscli-service";
import { decodeFeatureResponse, encodeForPost } from './settings.codec';
import { FEATURE_NAME, TranslationKeys, } from './settings.constants';
export const useChartSettings = () => {
    const [status, setStatus] = useState('loading');
    const [values, setValues] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [saveError, setSaveError] = useState(null);
    const [loadError, setLoadError] = useState(null);
    const previousValuesRef = useRef(null);
    const pendingResolveRef = useRef(null);
    const { data: settingsResponse, error: queryError, loading, } = useGetFeatureQuery(FEATURE_NAME);
    useEffect(() => {
        if (loading)
            return;
        if (queryError ||
            !settingsResponse?.Data ||
            settingsResponse?.Error) {
            setStatus('error');
            setLoadError(t(TranslationKeys.LOAD_FAILURE_MESSAGE));
            setValues({ newChartsDefault: true });
            return;
        }
        setValues(decodeFeatureResponse(settingsResponse.Data));
        setStatus('ready');
    }, [settingsResponse, loading, queryError]);
    const settleSave = (success, errorMessage) => {
        setIsSaving(false);
        if (!success) {
            if (previousValuesRef.current) {
                setValues(previousValuesRef.current);
            }
            setSaveError(errorMessage ||
                t(TranslationKeys.SAVE_FAILURE_MESSAGE));
        }
        previousValuesRef.current = null;
        pendingResolveRef.current?.({ success });
        pendingResolveRef.current = null;
    };
    const onComplete = (response) => {
        const success = !(response?.Error || !response?.Data);
        settleSave(success, response?.Error);
    };
    const onErrorCb = () => settleSave(false);
    const [updateSetting] = useSetTscliCommand(onComplete, onErrorCb, FEATURE_NAME, encodeForPost({ newChartsDefault: false }));
    const save = (next) => new Promise(resolve => {
        if (!values || isSaving) {
            resolve({ success: false });
            return;
        }
        previousValuesRef.current = values;
        setValues(next);
        setIsSaving(true);
        setSaveError(null);
        pendingResolveRef.current = resolve;
        updateSetting({
            variables: {
                featureName: FEATURE_NAME,
                params: encodeForPost(next),
            },
        });
    });
    return {
        status,
        values,
        isSaving,
        saveError,
        loadError,
        save,
        dismissSaveError: () => setSaveError(null),
        dismissLoadError: () => setLoadError(null),
    };
};
//# sourceMappingURL=use-chart-settings.js.map